<script setup lang="ts">
import { computed } from 'vue'
import { useSettingsStore } from '@/stores/settingsStore'

const settingsStore = useSettingsStore()

const isDecember = computed(() => {
  return new Date().getMonth() === 11
})

const toggleSnow = () => {
  settingsStore.toggleSnow()
}
</script>

<template>
  <button
    v-if="isDecember"
    @click="toggleSnow"
    class="p-2 rounded-full transition-colors bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 flex items-center justify-center"
    :title="settingsStore.snowEnabled ? 'Turn off snow' : 'Turn on snow'"
    aria-label="Toggle snow animation"
  >
    <span 
      class="text-lg leading-none transition-opacity duration-300"
      :class="settingsStore.snowEnabled ? 'opacity-100' : 'opacity-40'"
    >
      ❄
    </span>
  </button>
</template>
